import { NavigateFunction } from "react-router-dom";
import { AggregateWindow, FilterPoint} from "../types/types";

export const setFilterInURL = (filter: FilterPoint, location: string,  navigate: NavigateFunction, options?: { replace?: boolean }) => {
    const params = new URLSearchParams(location);

    for (const key in filter) {
        if (filter[key as keyof FilterPoint]) {
            params.set(key, filter[key as keyof FilterPoint] as string)
        } else {
            params.delete(key)
        }
    }
    const path = location.split('?')[0] + '?' + params.toString()
    // Utiliser les options passées ou replace: false par défaut pour préserver l'historique
    navigate(path, { replace: true })
}

export const getFilterFromURL = (location:string) : FilterPoint=> {
    const params = new URLSearchParams(location);
    
    return {
        startDate: params.get('startDate') || undefined,
        stopDate: params.get('stopDate') || undefined,
        device_name: params.get('device_name') || undefined,
        aggregateWindow: params.get('aggregateWindow') as AggregateWindow
    }
}